var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.img && _vm.img.phone)?_c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.img.phone},on:{"load":_vm.onLoad}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }